<template>
  <div>
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" />

    </eb-header>
    <div class="button-group">
      <el-button style="display:none" :disabled="isRenew" @click="showWeixinPayDialog" class="eb-button-red eb-button-small">续订</el-button>
      <el-button :disabled="isPushStatus" @click="onBusinessConfig(0)" class="eb-button-red eb-button-small">接收</el-button>
      <el-button :disabled="isPushStatus" @click="onBusinessConfig(1)" class="eb-button-red eb-button-small">停收</el-button>
    </div>
    <div class="table-box">
      <div class="eb-table">
        <el-table :data="tableData" :stripe="true" row-key="businessPushId" @selection-change="handleSelectionChange" ref="pushListRef" style="width: 100%">
          <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="75"></el-table-column>
          <el-table-column sortable prop="buyerDepartName" label="已订购机构名称"></el-table-column>
          <el-table-column sortable prop="pushStartDate" label="订购日期" width="200"></el-table-column>
          <el-table-column sortable prop="pushEndDate" label="到期日期" width="200"></el-table-column>
          <el-table-column sortable prop="pushStatus" label="信息接收状态" width="140"></el-table-column>
        </el-table>
      </div>
    </div>
    <eb-pagination class="pagination" :current-page.sync="pageNumber" v-if="recordsTotal" @current-change="onPagination" :total="recordsTotal" />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { userBusinessList, businessConfig, placeOrder } from '@/services/busi/business-push-service';
import moment from 'moment';
import EventBus from '@/plugins/event-bus';
import { getUserById } from '@/services/user/user-service';
export default {
  name: 'BusiOpptyPushList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebPagination
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      tableData: [],
      requestData: {
        userId: this.$store.state.user.userInfo.userid,
        start: 1,
        length: 10,
        searchText: ''
      },
      recordsTotal: 0,
      pageNumber: 1,
      businessPushIds: [],
      isRenew: true,
      isPushStatus: true,
      isOverdue: false,
      sysOrderNumber: '', // 系统订单号
      weixinPay: {
        isVisible: false,
        busiOpptyDesc: null,
        productId: null, // 商品id
        outTradeNo: null, // 订单号
        body: null, // 描述文字
        totalFee: null // 支付金额
      },
      busiOppty: {}
    };
  },
  created() {
    this.initUserBusinessList();
  },
  methods: {
    async initUserBusinessList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await userBusinessList(this.requestData);
        if (data.returnCode === '01') {
          this.tableData = this.dataFilter(data.data);
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('查询订阅列表失败');
        }
      } catch (error) {
        this.$message.error('查询订阅列表失败');
      }
      this.$root.layout.isLoading = false;
    },
    resetData: function() {
      this.requestData = {
        userId: this.user.userid,
        start: 1,
        length: 10,
        searchText: ''
      };
      this.recordsTotal = 0;
      this.pageNumber = 1;
      this.$refs.pushListRef.clearSelection();
      this.businessPushIds = [];
      this.isRenew = true;
      this.isPushStatus = true;
      this.isOverdue = false;
    },
    searchData: function(val) {
      this.resetData();
      this.requestData.searchText = val;
      this.initUserBusinessList();
    },
    onPagination: function(result) {
      this.requestData.start = result; // (result - 1) * 10 > 0 ? (result - 1) * 10 : 0;
      this.initUserBusinessList();
    },
    dataFilter: function(data) {
      var arr = [];
      if (data) {
        arr = data.map(element => {
          if (element['pushStatus']) {
            element['pushStatus'] = this.$options.filters['pushStatus'](element['pushStatus']);
          }
          if (element['pushStartDate']) {
            element['pushStartDate'] = this.$options.filters['dateTimeStandardFormatOblique'](element['pushStartDate']);
          }
          if (element['pushEndDate']) {
            element['pushEndDate'] = this.$options.filters['dateTimeStandardFormatOblique'](element['pushEndDate']);
          }
          return element;
        });
      }
      return arr;
    },
    handleSelectionChange: function(rows) {
      this.businessPushIds = [];
      this.isRenew = true;
      this.isPushStatus = true;
      this.isOverdue = false;
      if (rows.length > 0) {
        if (rows.length === 1) {
          this.isRenew = false;
        }
        this.isPushStatus = false;
        rows.forEach(element => {
          this.businessPushIds.push(element);
        });
      }
    },
    async onBusinessConfig(pushStatus) {
      if (this.businessPushIds.length > 0) {
        try {
          let businessPushIds = [];
          this.businessPushIds.forEach(element => {
            if (element.pushStatus === '到期') {
              this.isOverdue = true;
            } else {
              businessPushIds.push(element.businessPushId);
            }
          });
          if (businessPushIds.length === 0) {
            if (this.isOverdue) {
              this.$notify.error({
                title: '错误',
                message: '到期的无法设置状态'
              });
            }
            return false;
          }
          this.isPushStatus = true;
          businessPushIds = businessPushIds.join(',');
          let { data } = await businessConfig({ businessPushIds: businessPushIds, pushStatus: pushStatus });
          if (data.returnCode === '01') {
            this.$message.success('设置信息接收状态成功');
            if (this.isOverdue) {
              this.$notify.error({
                title: '错误',
                message: '到期的无法设置状态'
              });
            }
            this.resetData();
            this.initUserBusinessList();
          } else {
            this.$message.error('设置信息接收状态失败');
          }
        } catch (error) {
          this.$message.error('设置信息接收状态失败');
        }
      } else {
        this.$message.error('请选择订购企业');
      }
    },
    // 初始化业务订单编号
    async initOrderNo() {
      try {
        let params = {
          orderType: this.businessPushIds[0].orderType,
          buyerOrgId: this.businessPushIds[0].buyerOrgId
        };
        let { data } = await placeOrder(params);
        if (data.returnCode === '01') {
          this.sysOrderNumber = data.sysOrderNumber;
        } else {
          throw new Error('获取订单编号失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 显示微信支付对话框
    async showWeixinPayDialog() {
      // 显示支付窗口
      // 初始化订单号
      await this.initOrderNo();

      let startDate = moment().format('YYYY/MM/DD');
      let endDate = moment()
        .add(1, 'y')
        .subtract(1, 'd')
        .format('YYYY/MM/DD');
      let dateDuration = startDate + '~' + endDate;
      this.busiOppty = {
        orderType: this.businessPushIds[0].orderType,
        departId: this.businessPushIds[0].buyerOrgId,
        content: '易比得信息推送',
        amount: 1,
        startDate: startDate,
        endDate: endDate,
        busiOpptyDesc: '订购此机构的易比得信息推送，有效期12个月（' + dateDuration + '），服务费50元。'
      };
      // 显示微信支付窗口
      this.weixinPay.isVisible = true;
      // 初始化微信支付二维码
      EventBus.$emit('initWeixinPayQRCode', {
        productId: this.busiOppty.orderType,
        outTradeNo: this.sysOrderNumber,
        body: this.busiOppty.content,
        totalFee: this.busiOppty.amount
      });
    },
    // 保存支付信息
    async wxPaymentComplete(weixinPayInfo) {
      if (weixinPayInfo.status === 'SUCCESS') {
        this.goOrderSuccessPage();
      } else {
        this.$message.error('微信支付失败');
      }
    },
    async goOrderSuccessPage() {
      let { data: userData } = await getUserById(this.user.userid);
      if (userData.returnCode === '01') {
        let busiOpptyOrderSuccess = {
          orgName: this.busiOppty.departName
        };
        // 订购周期
        let dateDuration = this.busiOppty.startDate + '~' + this.busiOppty.endDate;
        if (userData.user.openidPublic) {
          let nickname = userData.user.nickname;
          // 已关注
          busiOpptyOrderSuccess.isSubscribe = true;
          busiOpptyOrderSuccess.msg =
            '您已成功订购信息推送服务12个月，有效期 ' +
            dateDuration +
            '。<br>相关商机将推送至您的微信号“' +
            nickname +
            '”。';
        } else {
          // 未关注
          busiOpptyOrderSuccess.isSubscribe = false;
          busiOpptyOrderSuccess.msg = '您已成功订购信息推送服务12个月，有效期 ' + dateDuration;
          busiOpptyOrderSuccess.subscribeMsg =
            '您还没有关注易比得微信公众号，因此无法及时收到推送信息。请您参考下图：退出登录，使用微信扫码功能绑定微信号后，即可收到新的商机推送。';
        }
        busiOpptyOrderSuccess.sysOrderNumber = this.sysOrderNumber;
        sessionStorage.setItem('busiOpptyOrderSuccess', JSON.stringify(busiOpptyOrderSuccess));
        this.$router.push({ path: '/busi/opptyorder/success' });
      }
    }
  }
};
</script>
<style scoped lang="less">
.button-group {
  display: flex;
  justify-content: flex-end;
  padding-right: 51px;
  padding-top: 30px;
}
</style>
